// Loops through featured collections and adds an incremental class to identify them then initialises a slick slider (prevents them from controlling each other)
var num = 0;
$('.featured-collection.slick').each(function(i, obj) {
  var slides_mobile = $(this).attr('data-slides-mobile');
  num++;
  $(this).addClass('id' + num);
  $(this).slick({
    speed: 300,
    easing: 'ease',
    slidesToShow: 4,
    slidesToScroll: 1,
    adaptiveHeight: true,
    infinite: true,
    arrows: true,
    dots: false,
    prevArrow: '<button type="button" class="slick-prev visually-hidden-device" aria-label="Previous Slide"><svg width="100%" height="100%" viewBox="0 0 20 20"><g transform="matrix(-0.00561986,-0.00561986,0.00561986,-0.00561986,7.09528,27.8618)"><path d="M510.38,1027.25L2151.09,1027.25L2151.09,2667.96" fill="none" stroke="currentColor" stroke-width="80"/></g></button>',
    nextArrow: '<button type="button" class="slick-next visually-hidden-device" aria-label="Next Slide"><svg width="100%" height="100%" viewBox="0 0 20 20"><g transform="matrix(0.00561986,0.00561986,-0.00561986,0.00561986,12.9047,-7.86183)"><path d="M510.38,1027.25L2151.09,1027.25L2151.09,2667.96"  fill="none" stroke="currentColor" stroke-width="80"/></g></svg></button>',
    asNavFor: '.featured-collection-wrapper .slider_dots.id' + num,
    instructionsText: 'This carousel contains products cards featuring images, name and price information, and links to product pages. Use the Previous and Next buttons to move between slides.',
    regionLabel: 'Featured Products Carousel',
    responsive: [
      {
        breakpoint: 989,
        settings: {
          slidesToShow: 3
        }
      },
      {
        breakpoint: 749,
        settings: {
          slidesToShow: parseInt(slides_mobile, 10)
        }
      }
    ]
  });
});
// Does the same with the dot navigation
var num = 0;
$('.featured-collection-wrapper .slider_dots').each(function(i, obj) {
  num++;
  $(this).addClass('id' + num);
  $(this).slick({
    speed: 300,
    easing: 'ease',
    slidesToShow: 2,
    slidesToScroll: 1,
    adaptiveHeight: true,
    infinite: true,
    arrows: false,
    dots: false,
    asNavFor: '.featured-collection.id' + num,
    centerMode: true,
    focusOnSelect: true,
    centerPadding: '10%'
  });
});
// Queues active cards of first Featured Collection to load in order, and sets all other cards as loaded (otherwise additional collections need to wait for every card of earlier collections to load)
var num = 0;
$('.featured-collection').each(function(i, obj) {
  num++;
  $(this).addClass('id' + num);
});
$('.featured-collection.id1 .slick-active .card-wrapper').each(function(i, obj) {
  $(this).delay(i*200).queue(function() {
    $(this).addClass('loaded').dequeue();
  });
});
$('.featured-collection.id1 .slick-slide:not(.slick-active) .card-wrapper, .featured-collection:not(.id1) .card-wrapper').each(function(i, obj) {
  $(this).addClass('loaded');
});